import { useEffect } from 'react'

const PIXEL_ID = '2095498077846022'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

/**
 * Injects the Meta Pixel base code and fires the initial PageView event.
 */
export function useMetaPixel(): void {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (window.fbq) {
      window.fbq('track', 'PageView')
      return
    }

    const n: any = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
    }
    window.fbq = n
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.alt = ''
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)

    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])
}

/** Fires the InitiateCheckout event when a CTA is clicked. */
export function trackCheckout(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', { value: 27, currency: 'USD' })
  }
}
